import { make } from 'vuex-pathify';
import { filter, keys, keyBy, sortBy, values } from 'lodash';

const styles = keyBy(
    [
        {
            id: 1,
            title: 'Aggressive',
            color: 'error',
            comics: [
                require('@/assets/comics/Comic01-1.png'),
                require('@/assets/comics/Comic01-2.png'),
                require('@/assets/comics/Comic01-3.png'),
                require('@/assets/comics/Comic01-4.png')
            ],
            summary:
                'All right.  So in that scenario you could tell Billi was getting all aggressive, calling Ron names and threatening him. And Ron reacted by getting angry and started threatening her back. Did you notice how Ron “mirrored” Billi’s behavior?  This is what often happens when you communicate aggressively: the other person escalates and “matches” – or exceeds – your level of aggression. If we’d have kept going, there might have been some serious fighting here. And you know some nosey person or store owner would’ve called the police or something. And at the end of all that drama, Billi still probably wouldn’t have gotten her money back.  So this was definitely a situation where being aggressive didn’t pay! Literally!',
            prompt: 'Can you think of a time in your life when you communicated aggressively to try to get your needs met? What happened?',
            text: '',
            video: {
                src: require('@/assets/videos/Video05_aggressive.mp4'),
                captions: require('@/assets/videos/Video05_aggressive.vtt'),
                started: false,
                completed: false
            }
        },
        {
            id: 2,
            title: 'Passive',
            color: 'warning',
            comics: [
                require('@/assets/comics/Comic02-1.png'),
                require('@/assets/comics/Comic02-2.png'),
                require('@/assets/comics/Comic02-3.png'),
                require('@/assets/comics/Comic02-4.png'),
                require('@/assets/comics/Comic02-5.png')
            ],
            summary:
                'How about Billi’s body language in this scenario? She was mumbling, hesitating, and nervous. She did not communicate very well. Ron certainly got his needs met, though: 20 more dollars from Billi!  She needed that money for rent and food! When you communicate passively, like Billi did here, people can walk all over you. And I want you to know that being passive isn’t the same as being shy—you can be shy and still stand up for yourself! Speaking up for yourself is an important part of protecting yourself!',
            prompt: 'Can you think of a time in your life when you communicated passively to get your needs met? What happened?',
            text: '',
            video: {
                src: require('@/assets/videos/Video05_passive.mp4'),
                captions: require('@/assets/videos/Video05_passive.vtt'),
                started: false,
                completed: false
            }
        },
        {
            id: 3,
            title: 'Assertive',
            color: 'info',
            comics: [
                require('@/assets/comics/Comic03-1.png'),
                require('@/assets/comics/Comic03-2.png'),
                require('@/assets/comics/Comic03-3.png'),
                require('@/assets/comics/Comic03-4.png')
            ],
            summary:
                'In this scenario, we can tell that Billi was being assertive because she said what was on her mind, she used a calm, even voice tone, and she didn’t back down. She showed respect for herself, so Ron had to show her respect too. She also asked Ron to step away from his friends so that he wouldn’t feel embarrassed and other people wouldn’t chime in with their unnecessary opinions.',
            prompt: 'Have you ever used an assertive communication style? What happened in that scenario?',
            text: '',
            video: {
                src: require('@/assets/videos/Video05_assertive.mp4'),
                captions: require('@/assets/videos/Video05_assertive.vtt'),
                started: false,
                completed: false
            }
        }
    ],
    'id'
);
const stylesOrder = sortBy(keys(styles), k => parseInt(k));

const state = {
    title: 'Communication Styles',
    complete: false,
    sticker: {
        text: 'Cell phone',
        earned: false,
        image: require('@/assets/stickers/stickers_0006_phone.png')
    },
    bonusSticker: false,
    trophy: false,
    styles,
    stylesOrder
};
const getters = {
    ...make.getters(state),
    allStylesEntered: state => {
        return 0 === filter(values(state.styles), { text: '' }).length;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
